import React from 'react'
import { Col } from "react-bootstrap"
import Cleave from 'cleave.js/react'
import { error, bordererror } from './style.js'

export function renderFormattedField( field )
{
 
    const inputstyle =  field.meta.touched && field.meta.error ? bordererror : {}
   
    return (       
            <Col className={field.inputattrs}>
                 <Cleave
                    {...field.input}            
                    placeholder={field.placeholder ? field.placeholder : ''}               
                    className="form-control"                   
                    title={field.title}   
                    style={inputstyle} 
                    name={field.name}  
                    options={field.options}  
                  
                    />    
                     {field.meta.touched && field.meta.error && <span style={error}>*{field.meta.error}</span>}         
            </Col>
    )   
}


// WEBPACK FOOTER //
// ./src/modules/components/formattedfield.js